/**
 * Gets a React component's display name, given a ReactType (i.e., a function,
 * class, or string). If unable to determine, returns "(unknown)".
 *
 * The returned name is suitable for display purposes and messaging only, and
 * should not be used for identity purposes.
 *
 * @param componentType The React component whose name to get.
 * @returns A display name for the component.
 */
export default function getComponentDisplayName(componentType: React.ReactType | string) {
  if (typeof componentType === 'string') {
    return componentType;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return componentType.displayName || (componentType as any).name || '(unknown)';
}
